import { render, staticRenderFns } from "./tickets-select.vue?vue&type=template&id=2fab5640"
import script from "./tickets-select.vue?vue&type=script&lang=js"
export * from "./tickets-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports